<script setup lang="ts">
import { computed } from 'vue';

import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import { formatMegabytes } from '@/utils/files';

/***
 * template to show megabyte value, formatted
 */
const props = defineProps<PaginatedDataTableCellProps>();
const megabytes = computed(() => formatMegabytes(props.cell as number));
</script>

<template>
  {{ megabytes }}
</template>
